export const LANGS = [
  { code: "en", label: "EN" },
  { code: "fr", label: "FR" },
  { code: "es", label: "ES" },
];

export const T = {
  en: {
    welcome:
      "👋 Welcome to ROK Motors! I'm your AI Assistant.\n\nI can help you buy vehicles from the USA & Canada, ship to Ghana, clear customs, arrange towing or transport, get an instant quote, or track your shipment.\n\nHow can I help you today?",
    placeholder: "Type your message…",
    online: "Online now",
    offline: "AI available 24/7",
    attach: "Attach document",
    analyzing: "Reading your document…",
  },
  fr: {
    welcome:
      "👋 Bienvenue chez ROK Motors ! Je suis votre assistant IA.\n\nJe peux vous aider à acheter des véhicules aux USA et au Canada, à expédier vers le Ghana, à dédouaner, à organiser le remorquage ou le transport, à obtenir un devis instantané ou à suivre votre expédition.\n\nComment puis-je vous aider aujourd'hui ?",
    placeholder: "Écrivez votre message…",
    online: "En ligne",
    offline: "IA disponible 24/7",
    attach: "Joindre un document",
    analyzing: "Lecture de votre document…",
  },
  es: {
    welcome:
      "👋 ¡Bienvenido a ROK Motors! Soy tu asistente de IA.\n\nPuedo ayudarte a comprar vehículos en EE. UU. y Canadá, enviarlos a Ghana, gestionar la aduana, organizar el remolque o transporte, obtener una cotización instantánea o rastrear tu envío.\n\n¿Cómo puedo ayudarte hoy?",
    placeholder: "Escribe tu mensaje…",
    online: "En línea",
    offline: "IA disponible 24/7",
    attach: "Adjuntar documento",
    analyzing: "Leyendo tu documento…",
  },
};

// key drives behaviour; label localized; msg sent to the AI for chat-type actions
export const QUICK_ACTIONS = [
  { key: "buy", msg: "I want to buy a vehicle from the USA or Canada.", en: "Buy a Vehicle", fr: "Acheter un véhicule", es: "Comprar un vehículo" },
  { key: "ship", msg: "I want to ship my vehicle to Ghana.", en: "Ship My Vehicle", fr: "Expédier mon véhicule", es: "Enviar mi vehículo" },
  { key: "customs", msg: "I need help with customs clearing in Ghana.", en: "Customs Clearing", fr: "Dédouanement", es: "Despacho de aduana" },
  { key: "transport", msg: "I need vehicle transport.", en: "Vehicle Transport", fr: "Transport de véhicule", es: "Transporte de vehículos" },
  { key: "emergency", msg: "", en: "Emergency Towing", fr: "Remorquage d'urgence", es: "Remolque de emergencia" },
  { key: "roadside", msg: "I need roadside assistance.", en: "Roadside Assistance", fr: "Assistance routière", es: "Asistencia en carretera" },
  { key: "quote", msg: "", en: "Get a Quote", fr: "Obtenir un devis", es: "Obtener cotización" },
  { key: "track", msg: "I'd like to track my shipment.", en: "Track Shipment", fr: "Suivre l'expédition", es: "Rastrear envío" },
  { key: "expert", msg: "", en: "Speak to an Expert", fr: "Parler à un expert", es: "Hablar con un experto" },
];
